import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import MainPage from "./MainPage/MainPage";
import ManuelPage from "./pages/ManuelPage";
import SemiPage from "./pages/SemiPage";
import AutoPage from "./pages/AutoPage";
import SEO from "./AnnexePages/SEO/SEO";
import SousTraitance from "./AnnexePages/Sous-Traitance/Sous-Traitance";
import Websites from "./AnnexePages/Websites/Websites";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Enregistrement centralisé et unique de ScrollTrigger
if (typeof window !== "undefined" && !gsap.plugins.ScrollTrigger) {
  gsap.registerPlugin(ScrollTrigger);
}

const App = () => {
  return (
    <div className="presentation-wrapper presentation-index-wrapper presentation-app-root-container">
      <div className="presentation-app-router-main-container">
        <div className="app">
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/automatique" element={<AutoPage />} />
            <Route path="/ia-vs-humain" element={<ManuelPage />} />
            <Route path="/gains-financiers" element={<SemiPage />} />
            <Route path="/seo" element={<SEO />} />
            <Route path="/marketing" element={<SEO />} />
            <Route path="/sous-traitance" element={<SousTraitance />} />
            <Route path="/websites" element={<Websites />} />
            <Route path="/web-design" element={<Websites />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default App;
